import { render, staticRenderFns } from "./ElementTag.vue?vue&type=template&id=5f82ac1a&scoped=true"
import script from "./ElementTag.vue?vue&type=script&lang=js"
export * from "./ElementTag.vue?vue&type=script&lang=js"
import style0 from "./ElementTag.vue?vue&type=style&index=0&id=5f82ac1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f82ac1a",
  null
  
)

export default component.exports